import { LIMPAR_DADOS_CTE_ENCOMENDA } from '../types';

export default function limparDadosCteEncomenda () {
  return {
    type: LIMPAR_DADOS_CTE_ENCOMENDA
  }
}
